import { useContext } from 'react'
import { FlowManagerContext } from '../contexts'

export const useFlowManager = () => useContext(FlowManagerContext)
